export default __webpack_public_path__ + "static/media/fireplace.06445d45.ogg";